import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  tatDescription,
  deliveryZoneEDescription
} from "app/main/shared/ts/description";
import { b2bZones, zones } from "app/main/shared/ts/courierRates";

@Component({
  selector: "app-card-view",
  templateUrl: "./card-view.component.html",
  styleUrls: ["./card-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardViewComponent {
  @Input() courierPrices: any[] = [];
  @Input() courierPartnerForm: FormGroup;
  @Output() courierPartnerValue = new EventEmitter();
  @Output() showShippingChargeInfo = new EventEmitter();

  b2bCourierZones = b2bZones;
  zones = zones;

  tatDescription = tatDescription;
  deliveryZoneEDescription = deliveryZoneEDescription;

  constructor(private _cd: ChangeDetectorRef) {}

  shippingChargeInfo(details, heading) {
    this.showShippingChargeInfo.emit({ details, heading });
  }

  markForCheck() {
    this._cd.markForCheck();
  }
}
